import type { InvoiceAssessmentModel } from "../models/InvoiceAssessment";

export function substituteTemplateVariables(
  content: string,
  invoice: InvoiceAssessmentModel
): string {
  const totalAmount =
    invoice.totalAmountWithVat != null && invoice.currencyCode
      ? new Intl.NumberFormat("sv-SE", {
          style: "currency",
          currency: invoice.currencyCode,
        }).format(invoice.totalAmountWithVat)
      : "";

  return content
    .replace(/\{\{issuer\}\}/g, invoice.invoiceIssuer?.client?.name ?? "")
    .replace(/\{\{invoiceNumber\}\}/g, invoice.invoiceNumber)
    .replace(
      /\{\{issuerOrganisationNumber\}\}/g,
      invoice.invoiceIssuer?.client?.id ?? ""
    )
    .replace(/\{\{totalAmount\}\}/g, totalAmount);
}

export function templateContentToHtml(content: string): string {
  return content
    .replace(/__(.+?)__/g, "<b>$1</b>")
    .replace(/_(.+?)_/g, "<i>$1</i>")
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/\n\n/g, "<br><br>")
    .replace(/\n/g, "<br>");
}
